import { useQuery } from "react-query";
import { _AccountApi } from "api/account/account";

export const useSupport = () => {
  const { data, isLoading } = useQuery(
    ["support"],
    () => _AccountApi.support().then((res) => res),
    {
      keepPreviousData: true,
    }
  );
  return {
    data,
    isLoading,
  };
};
